import React, { useEffect, useMemo, useRef, useState } from 'react'
import './Portfolio.css'
import './DepositCryptoV2.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Form } from 'react-bootstrap'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { styled } from '@mui/system'
import QrCodeIcon from '@mui/icons-material/QrCode'
import { useParams, useNavigate } from 'react-router-dom'
import { RiArrowDownSFill } from 'react-icons/ri'
import { FaLink } from "react-icons/fa6";
import { FaRegCopy } from "react-icons/fa6";
import { Button } from "@mui/material";
import $ from 'jquery'
import Config from '../../core/config'
import { makeRequest } from '../../core/services/v1/request'
import NavbarOne from '../../Pages/separate/NavbarOne'
import Footer from '../../Pages/separate/Footer'
import { toast } from '../../core/lib/toastAlert'
import ReactTooltip from 'react-tooltip'
import { shortAdrress } from '../../core/helper/short-address'
import { useContextData } from '../../core/context/index'
import '../../assets/style.css'
import Loader from '../../Component/Loader/Loader'

const DEPOSIT_FROM_OPTIONS = [
    { value: '1', label: 'Personal wallet' },
    { value: '0', label: 'Exchange or crypto service provider' },
];

const WALLET_OWNER_OPTIONS = [
    { value: 'self', label: 'My Wallet' },
    { value: 'other', label: "Another Person's Wallet" },
];

const UtrSelect = ({
    name, value, options, onChange, disabled,
    placeholder = 'Please select',
    searchable = false,
    loading = false,
    emptyText = 'No results found'
}) => {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');
    const ref = useRef(null);
    const searchRef = useRef(null);

    useEffect(() => {
        const onDocClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, []);

    useEffect(() => {
        if (open) {
            if (searchable && searchRef.current) searchRef.current.focus();
        } else {
            setQuery('');
        }
    }, [open, searchable]);

    const selected = options.find((o) => o.value === value);

    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        return q ? options.filter((o) => o.label.toLowerCase().includes(q)) : options;
    }, [options, query]);

    const pick = (val) => {
        setOpen(false);
        if (val !== value) {
            onChange({ target: { name, value: val, type: 'select-one' } });
        }
    };

    return (
        <div className={`utr-select ${open ? 'open' : ''}`} ref={ref}>
            <button
                type='button'
                className='utr-select-trigger'
                onClick={() => !disabled && setOpen((o) => !o)}
                onKeyDown={(e) => e.key === 'Escape' && setOpen(false)}
                disabled={disabled}
                aria-haspopup='listbox'
                aria-expanded={open}
            >
                <span className={`utr-select-value ${selected ? '' : 'placeholderTrv'}`}>
                    {loading && !selected ? 'Loading...' : selected ? selected.label : placeholder}
                </span>
                <svg className='utr-select-chevron' width='16' height='16' viewBox='0 0 24 24' fill='none'>
                    <path d='M6 9L12 15L18 9' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
            </button>

            {open && (
                <div className='utr-select-menu'>
                    {searchable && (
                        <div className='utr-select-search'>
                            <svg width='15' height='15' viewBox='0 0 24 24' fill='none'>
                                <circle cx='11' cy='11' r='7' stroke='currentColor' strokeWidth='2' />
                                <path d='M20 20L16.5 16.5' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
                            </svg>
                            <input
                                ref={searchRef}
                                type='text'
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') e.preventDefault();
                                    if (e.key === 'Escape') setOpen(false);
                                }}
                                autoComplete='off'
                            />
                        </div>
                    )}

                    <ul className='utr-select-list' role='listbox'>
                        {loading && <li className='utr-select-empty'>Loading...</li>}

                        {!loading && filtered.length === 0 && (
                            <li className='utr-select-empty'>{emptyText}</li>
                        )}

                        {!loading && filtered.map((opt) => (
                            <li
                                key={opt.value}
                                role='option'
                                aria-selected={opt.value === value}
                                className={`utr-select-option ${opt.value === value ? 'selected' : ''}`}
                                onClick={() => pick(opt.value)}
                            >
                                <span className='utr-select-label'>{opt.label}</span>
                                {opt.value === value && (
                                    <svg width='15' height='15' viewBox='0 0 24 24' fill='none'>
                                        <path d='M20 6L9 17L4 12' stroke='currentColor' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round' />
                                    </svg>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};
const StyledTableHeadRow = styled(TableCell)(({ theme }) => ({
    borderBottom: 'none',
    fontFamily:
        'Roboto, "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei"',
    fontSize: '22px',
    fontWeight: '600',
    fontStyle: 'normal',
    padding: '5px',
    paddingBottom: '16px',
    width: 'auto !important',
    color: 'white',
    textAlign: 'center'
}))
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    borderBottom: 'none',
    fontFamily:
        'Roboto, "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei"',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '27px',
    padding: '5px',
    width: 'auto !important',
    color: '#C8C8C8',
    textAlign: 'center'
}))

const StyledTableHead = styled(TableHead)(({ theme }) => ({
    borderBottom: 'none',
    fontFamily:
        'Roboto, "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei"',
    fontSize: '32px',
    fontWeight: '600',
    padding: '5px',
    fontStyle: 'normal',
    lineHeight: '38px',
    width: 'auto !important',
    color: 'white',
    textAlign: 'center'
}))

const DepositCrypto = props => {
    const navigate = useNavigate()

    let { currencyId } = useParams()
    const { myProfile } = useContextData()
    const [loader, setLoader] = useState(false)
    const [currencies, setCurrencies] = useState('')
    const [qrCode, setqrCode] = useState('')
    const [depositData, setdepositData] = useState({ address: '' })
    const [depositStatus, setdepositStatus] = useState(null)
    const [networkName, setnetworkName] = useState('')
    const [networkId, setnetworkId] = useState('')
    const [networkList, setnetworkList] = useState([])
    const [depositcryptoList, setdepositcryptoList] = useState([])
    const [defaultNetwork, setdefaultNetwork] = useState('')
    const [uniticCounts, setUniticCounts] = useState(0)
    const [defaultCurrency, setdefaultCurrency] = useState('')
    const [defaultCurrencyList, setdefaultCurrencyList] = useState({
        currencySymbol: '',
        image: ''
    })
    const [currencyList, setCurrencyList] = useState([])
    const [currencyID, setCurrencyID] = useState(currencyId)
    const [depositText, setDepositText] = useState('CLAIM DEPOSIT ?')
    const [particularCurrencyList, setparticularCurrencyList] = useState({})

    const [curCurrencySymbol, setCurCurrencySymbol] = useState('')
    const [depositPage, setDepositPage] = useState(1)
    const [depositPageCursors, setDepositPageCursors] = useState([null])
    const [depositNextPageCursor, setDepositNextPageCursor] = useState('')
    const [depositHistoryLoading, setDepositHistoryLoading] = useState(false)
    const [travelRuleModal, setTravelRuleModal] = useState(false)
    const [travelRuleErrors, setTravelRuleErrors] = useState("")
    const [selectedTravelRuleDeposit, setSelectedTravelRuleDeposit] =
        useState(null)
    const [vaspList, setVaspList] = useState([])
    const [vaspLoading, setVaspLoading] = useState(false)
    const [travelRuleSubmitting, setTravelRuleSubmitting] =
        useState(false)

    const [travelRuleForm, setTravelRuleForm] = useState({
        walletType: '1',
        legalType: 'individual',
        vaspCode: '',
        firstName: '',
        lastName: '',
        companyName: '',
        isSelfWallet: true,
        transactionPurpose: 'Cryptocurrency Deposit'
    })

    useEffect(() => {
        $('.crypto-workflow-section-close-button').click(function () {
            $('.deposit-second-section').hide()
        })
    }, [])

    useEffect(() => {
        if (myProfile && myProfile.email == '') {
            toast({ type: 'error', message: 'Please enable email verification' })
            navigate('/my/email-authenticator')
        }
        if (
            myProfile &&
            ((myProfile.additionalKyc.status !== 'manually_approved' &&
                myProfile.additionalBank.status !== 'manually_approved' &&
                myProfile.additionalKyc.status !== 'auto_approved' &&
                myProfile.additionalKyc.status !== 'approved' &&
                myProfile.additionalBank.status !== 'auto_approved' &&
                myProfile.additionalBank.status !== 'approved') ||
                myProfile?.kycOffline?.aadhaar?.status != 1 ||
                myProfile?.kycOffline?.aml?.status != 1 ||
                myProfile?.kycOffline?.identity?.status != 1)
        ) {
            toast({ type: 'error', message: 'Please complete the kyc details' })
            navigate('/my/identification')
        }
    }, [currencyId, myProfile])

    useEffect(() => {
        if (!myProfile) return
        async function getWalletCurrency() { }
        getWalletCurrency()
        getWalletCurrency_func()
        getparticularCurrency_func()
    }, [myProfile])
    useEffect(() => {
        if (defaultCurrencyList.currencySymbol == 'UNITIC') {
            checkDepositCrypto()
        }
    }, [myProfile, defaultCurrencyList])

    async function getparticularCurrency_func() {
        try {
            const params = {
                url: `${Config.V1_API_URL}wallet/getParticularCurrency`,
                method: 'POST',
                body: { CurrencyID: '' }
            }
            const response = await makeRequest(params)
            if (response.status && response.data) {
                setparticularCurrencyList(response.data)
            }
        } catch (err) { }
    }

    async function getWalletCurrency_func() {
        try {
            const params = {
                url: `${Config.V1_API_URL}wallet/getWalletCurrency`,
                method: 'GET'
            }

            const response = await makeRequest(params)

            const bybitWallet = Array.isArray(myProfile?.futuresSubAccount?.wallet)
                ? myProfile.futuresSubAccount.wallet
                : []

            if (!bybitWallet.length) {
                setCurrencyList([])
                setnetworkList([])
                setdepositData({ address: '' })
                setqrCode('')
                setnetworkName('')
                setdefaultNetwork('')
                return
            }

            const uniqueCurrencies = [
                ...new Map(
                    bybitWallet.map(item => [
                        String(item.currency || '').toUpperCase(),
                        item
                    ])
                ).values()
            ]

            let currencyArray = []

            if (response?.status && Array.isArray(response.data)) {
                currencyArray = response.data
                    .filter(item =>
                        uniqueCurrencies.some(
                            wallet =>
                                String(wallet.currency || '').toUpperCase() ===
                                String(item.currencySymbol || '').toUpperCase()
                        )
                    )
                    .map(item => ({
                        value: item._id,
                        currencySymbol: item.currencySymbol,
                        image: item.image,
                        currencyName: item.currencyName
                    }))
            }

            uniqueCurrencies.forEach(wallet => {
                const symbol = String(wallet.currency || '').toUpperCase()

                const exists = currencyArray.some(
                    item =>
                        String(item.currencySymbol || '').toUpperCase() === symbol
                )

                if (!exists) {
                    currencyArray.push({
                        value: symbol,
                        currencySymbol: symbol,
                        image: '',
                        currencyName: symbol
                    })
                }
            })

            setCurrencyList(currencyArray)

            const requestedCurrency = String(
                defaultCurrencyList?.currencySymbol ||
                ''
            ).toUpperCase()

            const routeCurrency = String(
                currencyId || ''
            ).toUpperCase()

            let selectedSymbol = requestedCurrency

            if (!selectedSymbol || selectedSymbol === 'UNDEFINED') {
                const matchedByOldId = response?.data?.find(
                    item => item._id == currencyId
                )

                if (matchedByOldId?.currencySymbol) {
                    selectedSymbol = String(
                        matchedByOldId.currencySymbol
                    ).toUpperCase()
                } else if (routeCurrency) {
                    const matchedWallet = uniqueCurrencies.find(
                        item =>
                            String(item.currency || '').toUpperCase() ===
                            routeCurrency
                    )

                    if (matchedWallet) {
                        selectedSymbol = routeCurrency
                    }
                }
            }

            if (!selectedSymbol) {
                selectedSymbol = String(
                    uniqueCurrencies[0]?.currency || ''
                ).toUpperCase()
            }

            const selectedWallets = bybitWallet.filter(
                item =>
                    String(item.currency || '').toUpperCase() ===
                    selectedSymbol
            )

            if (!selectedWallets.length) {
                selectedSymbol = String(
                    uniqueCurrencies[0]?.currency || ''
                ).toUpperCase()
            }

            const finalWallets = bybitWallet.filter(
                item =>
                    String(item.currency || '').toUpperCase() ===
                    selectedSymbol
            )

            const matchedCurrency =
                currencyArray.find(
                    item =>
                        String(item.currencySymbol || '').toUpperCase() ===
                        selectedSymbol
                ) || {}

            setdefaultCurrencyList({
                currencySymbol: selectedSymbol,
                image: matchedCurrency.image || ''
            })

            setCurCurrencySymbol(selectedSymbol)

            setnetworkList(finalWallets)

            const firstWallet = finalWallets[0]

            if (firstWallet) {
                setdefaultNetwork(
                    firstWallet._id ||
                    `${selectedSymbol}-${firstWallet.chain}`
                )

                setnetworkId(firstWallet._id || firstWallet.chain)

                setnetworkName(
                    firstWallet.chainType ||
                    firstWallet.chain ||
                    ''
                )

                setdepositData({
                    address: firstWallet.address || '',
                    chain: firstWallet.chain || '',
                    chainType: firstWallet.chainType || '',
                    currency: selectedSymbol
                })

                if (firstWallet.address) {
                    setqrCode(
                        `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(
                            firstWallet.address
                        )}`
                    )
                } else {
                    setqrCode('')
                }

                setdepositStatus(true)

                // Keep existing currency information for the UI
                if (response?.status && Array.isArray(response.data)) {
                    const oldCurrency = response.data.find(
                        item =>
                            String(item.currencySymbol || '').toUpperCase() ===
                            selectedSymbol
                    )

                    if (oldCurrency) {
                        setCurrencies(oldCurrency)
                    }
                }

                getparticularHistory(selectedSymbol)
            } else {
                setnetworkList([])
                setdepositData({ address: '' })
                setqrCode('')
                setnetworkName('')
                setdepositStatus(false)
                setdepositcryptoList([])
            }
        } catch (err) {
            console.log('getWalletCurrency_func', err)
        }
    }
    async function checkDepositCrypto() {
        try {
            const params = {
                url: `${Config.V1_API_URL}wallet/checkDepositCrypto`,
                method: 'POST',
                data: {
                    currencySymbol: 'UNITIC',
                    userId: myProfile._id,
                    basecoin: 'ARB20'
                }
            }
            const response = await makeRequest(params)
            if (response.status) {
                setUniticCounts(() => response?.totalAmount || 0)
            }
        } catch (err) { }
    }

    async function getparticularCurrencyDet(defaultNetwork) {
        try {
            const value = { CurrencyID: defaultNetwork }
            const params = {
                url: `${Config.V1_API_URL}wallet/getParticularCurrency`,
                method: 'POST',
                data: value
            }
            const result = await makeRequest(params)
            if (result.status) {
                if (result.data.depositEnable == 0) {
                    setdepositStatus(false)
                }
                setdepositStatus(true)
                setCurrencies(result.data)
                setnetworkName(result.data.basecoin)
            }
        } catch (err) { }
    }
    const openDepositDetails = (row) => {
        if (!row) return

        const txid =
            row?.txnId ||
            row?.txID

        if (!txid) return

        let explorer = 'https://bscscan.com/tx/'

        const chain = String(
            row?.chain || ''
        ).toUpperCase()

        if (
            chain === 'ETH' ||
            chain === 'ERC20'
        ) {
            explorer =
                'https://etherscan.io/tx/'
        } else if (
            chain === 'TRX' ||
            chain === 'TRC20'
        ) {
            explorer =
                'https://tronscan.org/#/transaction/'
        }

        window.open(
            `${explorer}${txid}`,
            '_blank'
        )
    }
    async function handlenetworkChange(networkId) {
        setnetworkId(networkId)

        const wallets = Array.isArray(
            myProfile?.futuresSubAccount?.wallet
        )
            ? myProfile.futuresSubAccount.wallet
            : []

        const selectedWallet = wallets.find(
            item =>
                item._id == networkId ||
                item.chain == networkId ||
                `${String(item.currency || '').toUpperCase()}-${item.chain}` ==
                networkId
        )

        if (!selectedWallet) {
            return
        }

        setnetworkName(
            selectedWallet.chainType ||
            selectedWallet.chain ||
            ''
        )

        setdefaultNetwork(
            selectedWallet._id ||
            `${String(selectedWallet.currency || '').toUpperCase()}-${selectedWallet.chain}`
        )

        setdepositData({
            address: selectedWallet.address || '',
            chain: selectedWallet.chain || '',
            chainType: selectedWallet.chainType || '',
            currency: selectedWallet.currency || ''
        })

        if (selectedWallet.address) {
            setqrCode(
                'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' +
                encodeURIComponent(selectedWallet.address)
            )
        } else {
            setqrCode('')
        }

        setdepositStatus(Boolean(selectedWallet.address))
    }
    async function getselectedNetwork(networkId) {
        try {
            const value = { CurrencyID: networkId }
            const params = {
                url: `${Config.V1_API_URL}wallet/getParticularCurrency`,
                method: 'POST',
                data: value
            }
            const response = await makeRequest(params)
            if (response.status) {
                if (response.data.depositEnable == 0) {
                    setdepositStatus(false)
                }
                setdepositStatus(true)
                setCurrencies(response.data)
                setnetworkName(response.data.basecoin)
            } else {
                navigate('/my/dashboard')
            }
        } catch (err) { }
    }
    async function createAddress(networkId) {
        try {
            const wallets = Array.isArray(
                myProfile?.futuresSubAccount?.wallet
            )
                ? myProfile.futuresSubAccount.wallet
                : []

            if (!wallets.length) {
                setdepositData({ address: '' })
                setqrCode('')
                return
            }

            const selectedWallet = wallets.find(
                item =>
                    item._id == networkId ||
                    item.chain == networkId ||
                    `${String(item.currency || '').toUpperCase()}-${item.chain}` ==
                    networkId
            )

            if (!selectedWallet) {
                return
            }

            setdepositData({
                address: selectedWallet.address || '',
                chain: selectedWallet.chain || '',
                chainType: selectedWallet.chainType || '',
                currency: selectedWallet.currency || ''
            })

            setnetworkName(
                selectedWallet.chainType ||
                selectedWallet.chain ||
                ''
            )

            setdepositStatus(Boolean(selectedWallet.address))

            if (selectedWallet.address) {
                const qrCode =
                    'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' +
                    encodeURIComponent(selectedWallet.address)

                setqrCode(qrCode)
            } else {
                setqrCode('')
            }
        } catch (err) {
            console.log('createAddress', err)
        }
    }
    //Config.FRONEND_URL
    async function handleCurrencyChange(currencyId) {
        window.history.pushState(
            {},
            '',
            Config.FRONEND_URL +
            'deposit/cryptodisabledlatest/' +
            currencyId
        )

        setCurrencyID(currencyId)

        await getSelectedCurrency(currencyId)
    }
    async function getSelectedCurrency(currencyValue) {
        try {
            const wallets = Array.isArray(
                myProfile?.futuresSubAccount?.wallet
            )
                ? myProfile.futuresSubAccount.wallet
                : []

            if (!wallets.length) {
                setnetworkList([])
                setdepositData({ address: '' })
                setqrCode('')
                setdepositcryptoList([])
                return
            }

            let selectedSymbol = ''

            try {
                const params = {
                    url: `${Config.V1_API_URL}wallet/getWalletCurrency`,
                    method: 'GET'
                }

                const response = await makeRequest(params)

                if (response?.status && Array.isArray(response.data)) {
                    const selectedOldCurrency = response.data.find(
                        item => item._id == currencyValue
                    )

                    if (selectedOldCurrency?.currencySymbol) {
                        selectedSymbol = String(
                            selectedOldCurrency.currencySymbol
                        ).toUpperCase()

                        setdefaultCurrencyList({
                            currencySymbol: selectedOldCurrency.currencySymbol,
                            image: selectedOldCurrency.image || ''
                        })
                    }
                }
            } catch (err) {
                console.log('getSelectedCurrency old currency lookup', err)
            }

            if (!selectedSymbol) {
                selectedSymbol = String(
                    currencyValue || ''
                ).toUpperCase()
            }

            const selectedWallets = wallets.filter(
                item =>
                    String(item.currency || '').toUpperCase() ===
                    selectedSymbol
            )

            if (!selectedWallets.length) {
                toast({
                    type: 'error',
                    message: 'Deposit wallet is not available for this currency.'
                })
                return
            }

            setnetworkList(selectedWallets)

            setdefaultCurrencyList(prev => ({
                ...prev,
                currencySymbol: selectedSymbol
            }))

            setCurCurrencySymbol(selectedSymbol)

            const firstWallet = selectedWallets[0]

            const firstNetworkId =
                firstWallet._id ||
                `${selectedSymbol}-${firstWallet.chain}`

            setdefaultNetwork(firstNetworkId)
            setnetworkId(firstNetworkId)

            setnetworkName(
                firstWallet.chainType ||
                firstWallet.chain ||
                ''
            )

            setdepositData({
                address: firstWallet.address || '',
                chain: firstWallet.chain || '',
                chainType: firstWallet.chainType || '',
                currency: selectedSymbol
            })

            setdepositStatus(Boolean(firstWallet.address))

            if (firstWallet.address) {
                setqrCode(
                    'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' +
                    encodeURIComponent(firstWallet.address)
                )
            } else {
                setqrCode('')
            }
            await getparticularHistory(selectedSymbol)
        } catch (err) {
            console.log('getSelectedCurrency', err)
        }
    }
    const formatBybitDate = (value) => {
        if (!value) return '-'

        const numericValue = Number(value)

        if (!numericValue || Number.isNaN(numericValue)) {
            return '-'
        }

        const date = new Date(numericValue)

        if (Number.isNaN(date.getTime())) {
            return '-'
        }

        const pad = (num) =>
            String(num).padStart(2, '0')

        return `${date.getFullYear()}-${pad(
            date.getMonth() + 1
        )}-${pad(date.getDate())} ${pad(
            date.getHours()
        )}:${pad(date.getMinutes())}:${pad(
            date.getSeconds()
        )}`
    }
    async function getparticularHistory(
        Currency,
        cursor = '',
        page = 1
    ) {
        setDepositHistoryLoading(true)

        try {
            const currency = String(
                Currency ||
                curCurrencySymbol ||
                defaultCurrencyList?.currencySymbol ||
                ''
            ).toUpperCase()

            if (!currency) {
                setdepositcryptoList([])
                setDepositNextPageCursor('')
                return
            }

            const requestData = {
                coin: currency,
                limit: 50
            }

            if (cursor) {
                requestData.cursor = cursor
            }

            const params = {
                url: `${Config.V1_API_URL}wallet/deposit-history`,
                method: 'POST',
                data: requestData
            }

            const response = await makeRequest(params)

            if (!response?.status) {
                setdepositcryptoList([])
                setDepositNextPageCursor('')
                return
            }

            const rawList =
                response?.data?.list ||
                response?.data?.rows ||
                response?.data ||
                []

            if (!Array.isArray(rawList)) {
                setdepositcryptoList([])
                setDepositNextPageCursor('')
                return
            }

            const walletList = Array.isArray(
                myProfile?.futuresSubAccount?.wallet
            )
                ? myProfile.futuresSubAccount.wallet
                : []

            const mappedData = rawList.map((item) => {
                const coin = String(
                    item?.coin || currency
                ).toUpperCase()

                const matchedWallet = walletList.find(
                    (wallet) =>
                        String(
                            wallet?.currency || ''
                        ).toUpperCase() === coin &&
                        (
                            String(
                                wallet?.chain || ''
                            ).toUpperCase() ===
                            String(
                                item?.chain || ''
                            ).toUpperCase()
                        )
                )

                const travelRuleStatus = String(
                    item?.travelRuleStatus ?? ''
                )

                const travelRuleApproved =
                    item?.travelRuleApproved === true ||
                    travelRuleStatus === '0'

                const travelRulePending =
                    item?.travelRulePending === true ||
                    travelRuleStatus === '2'

                const travelRuleRejected =
                    item?.travelRuleRejected === true ||
                    travelRuleStatus === '3'

                const needsTravelRule =
                    item?.needsTravelRule === true ||
                    travelRuleStatus === '1'

                const depositStatus = String(
                    item?.status ??
                    item?.depositStatus ??
                    ''
                )

                let depositStatusText = 'Processing'

                if (
                    depositStatus === '3' ||
                    depositStatus === '10012'
                ) {
                    depositStatusText = 'Completed'
                } else if (
                    depositStatus === '1'
                ) {
                    depositStatusText = 'To Be Confirmed'
                } else if (
                    depositStatus === '2'
                ) {
                    depositStatusText = 'Processing'
                } else if (
                    depositStatus === '4'
                ) {
                    depositStatusText = 'Failed'
                } else if (
                    depositStatus === '10011'
                ) {
                    depositStatusText = 'Pending'
                } else if (
                    depositStatus === '7'
                ) {
                    depositStatusText = 'Rollback Processing'
                } else if (
                    depositStatus === '70011'
                ) {
                    depositStatusText = 'Rolled Back'
                } else if (
                    depositStatus === '70013'
                ) {
                    depositStatusText = 'Manual Review'
                }

                let displayStatus =
                    item?.displayStatus ||
                    depositStatusText

                if (travelRuleApproved) {
                    displayStatus =
                        'Verification successful'
                } else if (travelRulePending) {
                    displayStatus =
                        'Verification pending'
                } else if (travelRuleRejected) {
                    displayStatus =
                        'Verification rejected'
                } else if (needsTravelRule) {
                    displayStatus =
                        'Verification required'
                }

                return {
                    ...item,

                    id:
                        item?.id ||
                        item?.depositId ||
                        item?.txID,

                    currencySymbol: coin,

                    amount:
                        item?.amount ??
                        '0',

                    txnId:
                        item?.txID ||
                        '-',

                    chain:
                        item?.chain ||
                        matchedWallet?.chain ||
                        '-',

                    chainType:
                        matchedWallet?.chainType ||
                        item?.chain ||
                        '-',

                    address:
                        item?.toAddress ||
                        item?.address ||
                        matchedWallet?.address ||
                        '',

                    fromAddress:
                        item?.fromAddress ||
                        '',

                    createdDate:
                        item?.successAt ||
                        item?.timestamp ||
                        item?.createdDate ||
                        null,

                    depositStatus,

                    depositStatusText,

                    travelRuleStatus,

                    travelRuleApproved,

                    travelRulePending,

                    travelRuleRejected,

                    needsTravelRule,

                    displayStatus,

                    image:
                        defaultCurrencyList?.image ||
                        matchedWallet?.image ||
                        ''
                }
            })

            setdepositcryptoList(mappedData)

            const nextCursor =
                response?.nextPageCursor ||
                response?.data?.nextPageCursor ||
                ''

            setDepositNextPageCursor(
                nextCursor || ''
            )

            setDepositPage(page)

            setDepositPageCursors((prev) => {
                const updated = [...prev]

                if (
                    updated[page - 1] === undefined
                ) {
                    updated[page - 1] =
                        cursor || null
                }

                return updated
            })
        } catch (error) {
            console.log(
                'getparticularHistory',
                error
            )

            setdepositcryptoList([])
            setDepositNextPageCursor('')
        } finally {
            setDepositHistoryLoading(false)
        }
    }

    const loadVaspList = async () => {
        if (vaspList.length > 0 || vaspLoading) return

        try {
            setVaspLoading(true)

            const response = await makeRequest({
                url: `${Config.V1_API_URL}wallet/travel-rule/vasp-list`,
                method: 'GET'
            })

            if (response?.status && Array.isArray(response.data)) {
                setVaspList(response.data)
            } else {
                toast({
                    type: 'error',
                    message: response?.message || 'Unable to load exchange list.'
                })
            }
        } catch (err) {
            console.log('loadVaspList', err)
            toast({ type: 'error', message: 'Unable to load exchange list.' })
        } finally {
            setVaspLoading(false)
        }
    }

    const openTravelRuleModal = deposit => {
        setTravelRuleErrors(() => '')
        setSelectedTravelRuleDeposit(deposit)

        setTravelRuleForm({
            walletType: '1',
            walletOwner: 'self',
            vaspCode: '',
            legalType: 'individual',
            firstName: '',
            lastName: '',
            companyName: '',
            confirmed: false
        })

        setTravelRuleModal(true)
        loadVaspList()
    }

    const isTravelRuleFormValid = () => {
        const f = travelRuleForm
        if (!f.confirmed) return false

        const isExchange = f.walletType === '0'
        const isSelfWallet = !isExchange && f.walletOwner === 'self'

        if (isExchange && !f.vaspCode) return false

        if (!isSelfWallet) {
            if (f.legalType === 'individual') {
                if (!(f.firstName || '').trim() || !(f.lastName || '').trim()) return false
            } else if (!(f.companyName || '').trim()) {
                return false
            }
        }

        return true
    }

    const submitTravelRule = async e => {
        e.preventDefault()
        setTravelRuleErrors(() => '')

        if (travelRuleSubmitting) return

        if (!selectedTravelRuleDeposit?.id) {
            setTravelRuleErrors(() => 'Deposit information is missing.')
            // toast({ type: 'error', message: 'Deposit information is missing.' })
            return
        }

        const f = travelRuleForm
        const isExchange = f.walletType === '0'
        const isSelfWallet = !isExchange && f.walletOwner === 'self'
        const needsOriginator = !isSelfWallet

        if (isExchange && !f.vaspCode) {
            setTravelRuleErrors(() => 'Please select the originating exchange.')
            // toast({ type: 'error', message: 'Please select the originating exchange.' })
            return
        }

        if (needsOriginator && f.legalType === 'individual' &&
            (!(f.firstName || '').trim() || !(f.lastName || '').trim())) {
            setTravelRuleErrors(() => 'Please enter first name and last name.')
            // toast({ type: 'error', message: 'Please enter first name and last name.' })
            return
        }

        if (needsOriginator && f.legalType === 'company' && !(f.companyName || '').trim()) {
            setTravelRuleErrors(() => 'Please enter the company name.')
            // toast({ type: 'error', message: 'Please enter the company name.' })
            return
        }

        if (!f.confirmed) {
            setTravelRuleErrors(() => 'Please confirm that the information provided is complete and correct.')
            // toast({
            //     type: 'error',
            //     message: 'Please confirm that the information provided is complete and correct.'
            // })
            return
        }

        setTravelRuleSubmitting(true)

        try {
            const questionnaire = {
                walletType: Number(f.walletType),
                legalType: needsOriginator ? f.legalType : 'individual',
                ...(isExchange
                    ? { vaspCode: f.vaspCode }
                    : { isSelfWallet }),
                ...(needsOriginator
                    ? (f.legalType === 'individual'
                        ? { firstName: f.firstName.trim(), lastName: f.lastName.trim() }
                        : { companyName: f.companyName.trim() })
                    : {})
            }

            const params = {
                url: `${Config.V1_API_URL}wallet/travel-rule/submit`,
                method: 'POST',
                data: {
                    id: selectedTravelRuleDeposit.id,
                    questionnaire
                }
            }

            const response = await makeRequest(params)

            if (response?.status) {
                toast({
                    type: 'success',
                    message: response?.message || 'Travel Rule information submitted successfully.'
                })

                setTravelRuleModal(false)
                setSelectedTravelRuleDeposit(null)

                setDepositPage(1)
                setDepositPageCursors([null])

                await getparticularHistory(
                    curCurrencySymbol || defaultCurrencyList?.currencySymbol,
                    '',
                    1
                )
                setTimeout(() => {
                    getparticularHistory(
                        curCurrencySymbol || defaultCurrencyList?.currencySymbol,
                        '',
                        1
                    )
                }, 2000)
            } else {
                setTravelRuleErrors(() => response?.message || response?.msg || 'Unable to submit Travel Rule information.')
                toast({
                    type: 'error',
                    message: response?.message || response?.msg || 'Unable to submit Travel Rule information.'
                })
            }
        } catch (err) {
            console.log('submitTravelRule', err)
            setTravelRuleErrors(() => err?.message || 'Something went wrong while submitting Travel Rule information.')
            toast({
                type: 'error',
                message: err?.message || 'Something went wrong while submitting Travel Rule information.'
            })
        } finally {
            setTravelRuleErrors(() => '')
            setTravelRuleSubmitting(false)
        }
    }

    const closeTravelRuleModal = () => {
        if (travelRuleSubmitting) return

        setTravelRuleModal(false)
        setSelectedTravelRuleDeposit(null)
        setTravelRuleErrors(() => '')
    }

    const handleTravelRuleChange = e => {
        const { name, value, type, checked } = e.target

        setTravelRuleForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }))
    }

    // const missingDeposit = async () => {
    //     setDepositText('Loading...')
    //     const params = {
    //         url: `${Config.V1_API_URL}wallet/depositETHTRX`,
    //         method: 'GET'
    //     }
    //     const response = await makeRequest(params)
    //     if (response.status) {
    //         let type = 'success'
    //         toast({ type, message: 'Success' })
    //         setDepositText('CLAIM DEPOSIT ?')
    //     } else {
    //         // let type = 'error';
    //         // toast({ type, message: response.msg });
    //         setDepositText('CLAIM DEPOSIT ?')
    //     }
    //     getparticularHistory(curCurrencySymbol)
    // }
    const missingDeposit = async () => {
        setDepositText('Loading...')

        try {
            await getparticularHistory(
                curCurrencySymbol ||
                defaultCurrencyList?.currencySymbol
            )

            toast({
                type: 'success',
                message: 'Deposit history refreshed successfully.'
            })
        } catch (err) {
            toast({
                type: 'error',
                message: 'Unable to refresh deposit history.'
            })
        } finally {
            setDepositText('CLAIM DEPOSIT ?')
        }
    }
    function copyToColumn(data = {}) {
        var input = document.createElement('input')
        document.body.appendChild(input)
        input.value = data.text
        input.select()
        document.execCommand('Copy')
        input.remove()
        toast({ type: 'success', message: data.message })
    }

    const handleSearch = e => {
        const searchval = e.target.value
        if (searchval !== '') {
            let results = []
            results = currencyList.filter(item => {
                return (
                    item.currencySymbol
                        .split('_')
                        .join('/')
                        .toLowerCase()
                        .indexOf(searchval.toLowerCase()) >= 0 ||
                    item.currencySymbol.toLowerCase().indexOf(searchval.toLowerCase()) >=
                    0
                )
            })
            if (results.length > 0) {
                setCurrencyList(results)
            } else {
                setCurrencyList([])
            }
        } else {
            getWalletCurrency_func()
        }
    }

    function bonusAmount(trxn) {
        try {
            if (typeof trxn.bonusData == 'object' && trxn.bonusData.bonusGiven > 0) {
                return trxn.bonusData.bonusGiven.toFixed(trxn.currencyId.siteDecimal)
            } else {
                if (trxn.depositType == 'Pre Booking') {
                    return '-'
                } else {
                    return 'NA'
                }
            }
        } catch (err) { }
    }

    const copyToClipboard = (data = {}) => {
        toast({ type: 'success', message: data.message })
    }
    return (
        <section>
            <NavbarOne setTheme={props.setTheme} theme={props.theme} />
            <h1 className='visually-hidden'>Deposit Crypto</h1>
            <div className='min-vh-100 bg-default text-light pb-5 pt-3'>
                <div className='container pb-5 pt-2'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h4
                            className='mb-0 controlFont'
                            style={{ cursor: 'pointer' }}
                            onClick={() => navigate('/my/dashboard')}
                        >
                            <strong>
                                <ArrowBackIcon style={{ cursor: 'pointer' }} /> Deposit Crypto
                            </strong>
                        </h4>
                        <h5
                            className='mb-0 controlFont'
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                                navigate('/deposit/fiat/' + particularCurrencyList?._id)
                            }
                        >
                            <strong>
                                Deposit Fiat <ArrowForwardIcon style={{ cursor: 'pointer' }} />
                            </strong>
                        </h5>
                    </div>
                    <div className='mx-auto text-center my-5 pb-3'>
                        <img src='/assets/deposit.png' alt='' className='img-fluid' />
                    </div>

                    <div className='withdraw-box mx-auto my-5 pb-4'>
                        <h5 className='text-center py-4 fw-bold'>Crypto Deposit</h5>
                        <div>
                            <Form className='w-75  mx-auto'>
                                <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                >
                                    <Form.Label>Select Crypto</Form.Label>

                                    <div
                                        className='d-flex flex-row align-items-center deposit-select-coin-section'
                                        data-bs-toggle='modal'
                                        data-bs-target='#selectcoinModal'
                                    >
                                        <div className=''>
                                            <img
                                                src={defaultCurrencyList && defaultCurrencyList.image}
                                                className='deposit-logo-image'
                                                alt='logo'
                                            />
                                            <span key={'i'} className='deposit-text-4'>
                                                {' '}
                                                {defaultCurrencyList &&
                                                    defaultCurrencyList.currencySymbol}{' '}
                                            </span>
                                        </div>
                                        <div className='ms-auto'>
                                            <RiArrowDownSFill />
                                        </div>
                                    </div>
                                </Form.Group>
                                <Form.Group
                                    className='mb-3'
                                    controlId='exampleForm.ControlInput1'
                                >
                                    <Form.Label>Deposit Network</Form.Label>
                                    <div
                                        className='d-flex flex-row align-items-center deposit-select-coin-section'
                                        data-bs-toggle='modal'
                                        data-bs-target='#depositnetworkModal'
                                    >
                                        <div className=''>
                                            {/* <img src="https://seeklogo.com/images/E/ethereum-logo-EC6CDBA45B-seeklogo.com.png" className='deposit-logo-image' alt="logo" /> */}
                                            <span className='deposit-text-4'></span>
                                            <span className='deposit-text-5 text-light'>
                                                {networkName == 'Coin'
                                                    ? defaultCurrencyList.currencySymbol
                                                    : networkName}
                                            </span>
                                        </div>
                                        <div className='ms-auto'>
                                            <RiArrowDownSFill />
                                        </div>
                                    </div>
                                </Form.Group>
                            </Form>

                            <div
                                style={{
                                    color: '#C8C8C8',
                                    fontSize: '14px',
                                    fontFamily:
                                        'Roboto, "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei"'
                                }}
                                className='w-75 mx-auto'
                            >
                                {defaultCurrency == 'INR' ? (
                                    <div className='deposit-third-right-section'>
                                        <span className='deposit-text-33'>
                                            {currencies?.depositEnable == 0
                                                ? defaultCurrency + '  Deposit Disabled'
                                                : ''}
                                        </span>
                                    </div>
                                ) : (
                                    <div className='deposit-third-right-section'>
                                        <span className='deposit-text-33'>
                                            {currencies?.depositEnable == 0 ||
                                                (currencies?.currencySymbol === 'UNITIC' &&
                                                    uniticCounts >= 10000)
                                                ? networkName + '  Deposit Disabled'
                                                : ''}
                                        </span>
                                    </div>
                                )}
                                {currencies?.depositEnable != 0 &&
                                    depositStatus == true &&
                                    !(
                                        currencies?.currencySymbol === 'UNITIC' &&
                                        uniticCounts >= 10000
                                    ) && (
                                        <>
                                            {/* {depositData && depositData.tag != '' && (
                                                <>
                                                    <span className='deposit-text-33'>Tag</span>
                                                    <div className='d-flex flex-row'>
                                                        <div className=''>
                                                            <span className='deposit-text-6'>
                                                                {depositData && depositData.tag ? (
                                                                    depositData.tag
                                                                ) : (
                                                                    <>&nbsp;</>
                                                                )}
                                                            </span>
                                                        </div>
                                                        <div className='ms-auto'>
                                                            <span data-tip data-for='noOverridePosition'>
                                                                <RiFileCopyFill
                                                                    className='deposit-icon-1'
                                                                    onClick={() =>
                                                                        copyToColumn({
                                                                            message:
                                                                                'Destination Tag copied successfully!',
                                                                            text:
                                                                                depositData && depositData.tag != ''
                                                                                    ? depositData.tag
                                                                                    : '-'
                                                                        })
                                                                    }
                                                                />
                                                            </span>
                                                            <ReactTooltip
                                                                id='noOverridePosition'
                                                                place='top'
                                                                className='tooltip-text-Theme text-center'
                                                            >
                                                                <span className='tooltip-text-1'>
                                                                    Click to Copy
                                                                </span>
                                                            </ReactTooltip>
                                                        </div>
                                                    </div>
                                                </>
                                            )} */}

                                            <p className='pb-3 text-wrap'>
                                                Address :{' '}
                                                {depositData && depositData.address ? (
                                                    depositData.address
                                                ) : (
                                                    <>&nbsp;</>
                                                )}{' '}
                                                <CopyToClipboard
                                                    text={`${depositData && depositData.address != ''
                                                        ? depositData.address
                                                        : '-'
                                                        }`}
                                                    onCopy={() =>
                                                        copyToClipboard({
                                                            message: 'Address copied successfully!'
                                                        })
                                                    }
                                                >
                                                    <ContentCopyIcon
                                                        fontSize='small'
                                                        sx={{ cursor: 'pointer' }}
                                                    />
                                                </CopyToClipboard>
                                                <>
                                                    <span data-tip data-for='noOverridePosition2'>
                                                        <QrCodeIcon
                                                            fontSize='small'
                                                            sx={{ cursor: 'pointer' }}
                                                        />
                                                    </span>
                                                    <ReactTooltip
                                                        id='noOverridePosition2'
                                                        effect='solid'
                                                        place='bottom'
                                                        className='tooltip-text-Theme'
                                                    >
                                                        <span className='tooltip-text-1'>
                                                            Scan the code on the withdrawal page of the
                                                            platform APP or Wallet APP
                                                        </span>
                                                        <br />
                                                        {qrCode && (
                                                            <img
                                                                className='qr-code-tooltip-image my-2'
                                                                alt='qr-code'
                                                                src={qrCode}
                                                            />
                                                        )}
                                                        <ul className='p-0 ps-2'>
                                                            <li className='tooltip-text-1'>
                                                                Send only {currencies.currencySymbol}{' '}
                                                                {currencies.basecoin != 'Coin'
                                                                    ? '- ' + currencies.basecoin
                                                                    : ''}{' '}
                                                                to this deposit address.
                                                            </li>
                                                            <li className='tooltip-text-1'>
                                                                Ensure the network is{' '}
                                                                {networkName == 'Coin'
                                                                    ? defaultCurrencyList.currencySymbol
                                                                    : networkName}
                                                            </li>
                                                        </ul>
                                                    </ReactTooltip>
                                                </>
                                            </p>
                                            <li>
                                                Minimum deposit More than{' '}
                                                <span className='deposit-text-9'>
                                                    {currencies?.mindepamt} {currencies.currencySymbol}
                                                </span>
                                                , deposits below that cannot be recovered.
                                            </li>
                                            <li>
                                                Send only{' '}
                                                <span className='deposit-text-9'>
                                                    {currencies.currencySymbol}{' '}
                                                    {currencies.basecoin != 'Coin'
                                                        ? '- ' + currencies.basecoin
                                                        : ''}
                                                </span>{' '}
                                                to this deposit address.
                                            </li>

                                            <li className='pb-5'>
                                                {currencies.depositNotes && (
                                                    <li>
                                                        <span className='deposit-text-3'>
                                                            {currencies.depositNotes}
                                                        </span>
                                                    </li>
                                                )}
                                            </li>
                                        </>
                                    )}
                            </div>
                        </div>
                    </div>

                    <div className='mt-5 pt-4'>
                        <h4 className='pb-2 fw-bold'>Recent Deposit</h4>
                        {/* <p className='pb-2 ps-3 ps-md-5 ,b-4'>
                            If your previous deposit is not reflecting, you can claim your
                            deposit below &nbsp;
                        </p> */}
                        {/* <button
                            className='btn-profile shadow mb-2 ms-3 ms-md-5 mb-4'
                            style={{
                                width: 'auto',
                                fontSize: '16px',
                                display:
                                    currencies?.currencySymbol === 'UNITIC' &&
                                        uniticCounts >= 10000
                                        ? 'none'
                                        : ''
                            }}
                            onClick={() => missingDeposit()}
                        >
                            {depositText}
                        </button> */}
                        {loader ? (
                            <Loader />
                        ) : (
                            <TableContainer>
                                <Table
                                    sx={{
                                        minWidth: window.innerWidth < 700 ? 1000 : 100,
                                        justifyContent: 'center'
                                    }}
                                    aria-label='simple table'
                                >
                                    <StyledTableHead>
                                        <TableRow>
                                            <StyledTableHeadRow>
                                                Assets
                                            </StyledTableHeadRow>

                                            <StyledTableHeadRow>
                                                Network
                                            </StyledTableHeadRow>

                                            <StyledTableHeadRow>
                                                Amount
                                            </StyledTableHeadRow>

                                            {/* <StyledTableHeadRow>
                                                Address
                                            </StyledTableHeadRow> */}

                                            <StyledTableHeadRow>
                                                Txn.id
                                            </StyledTableHeadRow>

                                            <StyledTableHeadRow>
                                                Status
                                            </StyledTableHeadRow>

                                            <StyledTableHeadRow>
                                                Date
                                            </StyledTableHeadRow>

                                            <StyledTableHeadRow>
                                                Action
                                            </StyledTableHeadRow>
                                        </TableRow>
                                    </StyledTableHead>
                                    <TableBody>
                                        {depositcryptoList.length > 0 &&
                                            depositcryptoList.map((row, i) => {
                                                if (row) {
                                                    return (
                                                        <TableRow
                                                            key={
                                                                row?.id ||
                                                                row?.txID ||
                                                                i
                                                            }
                                                        >
                                                            {/* Coin */}
                                                            <StyledTableCell
                                                                component='th'
                                                                scope='row'
                                                            >
                                                                <div
                                                                    className='d-flex align-items-center'
                                                                    style={{
                                                                        gap: '8px'
                                                                    }}
                                                                >
                                                                    {row?.image ? (
                                                                        <img
                                                                            src={row.image}
                                                                            alt={
                                                                                row?.currencySymbol ||
                                                                                'Crypto'
                                                                            }
                                                                            width='24'
                                                                            height='24'
                                                                            style={{
                                                                                width: '24px',
                                                                                height: '24px',
                                                                                borderRadius: '50%'
                                                                            }}
                                                                        />
                                                                    ) : null}

                                                                    <span>
                                                                        {row?.currencySymbol ||
                                                                            '-'}
                                                                    </span>
                                                                </div>
                                                            </StyledTableCell>

                                                            {/* Chain Type */}
                                                            <StyledTableCell>
                                                                <span
                                                                    style={{
                                                                        fontWeight: 600
                                                                    }}
                                                                >
                                                                    {row?.chainType ||
                                                                        row?.chain ||
                                                                        '-'}
                                                                </span>
                                                            </StyledTableCell>

                                                            {/* Quantity */}
                                                            <StyledTableCell>
                                                                {row?.amount ?? '-'}
                                                            </StyledTableCell>

                                                            {/* Address */}
                                                            {/* <StyledTableCell>
                                                                <div
                                                                    className='d-flex align-items-center'
                                                                    style={{
                                                                        gap: '7px'
                                                                    }}
                                                                >
                                                                    <span>
                                                                        {shortAdrress(
                                                                            row?.address ||
                                                                            '-'
                                                                        )}
                                                                    </span>

                                                                    {row?.address ? (
                                                                        <>
                                                                            <span
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    color: '#9AA6B2'
                                                                                }}
                                                                                onClick={() =>
                                                                                    window.open(
                                                                                        `https://bscscan.com/address/${row.address}`,
                                                                                        '_blank'
                                                                                    )
                                                                                }
                                                                                title='View address'
                                                                            >
                                                                                <i className='fa fa-link' />
                                                                            </span>

                                                                            <span
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    color: '#9AA6B2'
                                                                                }}
                                                                                onClick={() =>
                                                                                    copyToColumn({
                                                                                        text:
                                                                                            row.address,
                                                                                        message:
                                                                                            'Address copied successfully!'
                                                                                    })
                                                                                }
                                                                                title='Copy address'
                                                                            >
                                                                                <i className='fa fa-copy' />
                                                                            </span>
                                                                        </>
                                                                    ) : null}
                                                                </div>
                                                            </StyledTableCell> */}

                                                            {/* TxID */}
                                                            <StyledTableCell>
                                                                <div
                                                                    className='d-flex align-items-center justify-content-center'
                                                                    style={{
                                                                        gap: '7px'
                                                                    }}
                                                                >
                                                                    <span>
                                                                        {shortAdrress(
                                                                            row?.txnId ||
                                                                            row?.txID ||
                                                                            '-'
                                                                        )}
                                                                    </span>

                                                                    {(row?.txnId ||
                                                                        row?.txID) ? (
                                                                        <>
                                                                            <span
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    color: '#9AA6B2'
                                                                                }}
                                                                                onClick={() =>
                                                                                    window.open(
                                                                                        `https://bscscan.com/tx/${row?.txnId ||
                                                                                        row?.txID
                                                                                        }`,
                                                                                        '_blank'
                                                                                    )
                                                                                }
                                                                                title='View transaction'
                                                                            >
                                                                                <FaLink />
                                                                            </span>

                                                                            <span
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    color: '#9AA6B2'
                                                                                }}
                                                                                onClick={() =>
                                                                                    copyToColumn({
                                                                                        text:
                                                                                            row?.txnId ||
                                                                                            row?.txID,
                                                                                        message:
                                                                                            'Txn ID copied successfully!'
                                                                                    })
                                                                                }
                                                                                title='Copy transaction ID'
                                                                            >
                                                                                <FaRegCopy />
                                                                            </span>
                                                                        </>
                                                                    ) : null}
                                                                </div>
                                                            </StyledTableCell>

                                                            {/* Status */}
                                                            <StyledTableCell>
                                                                <span
                                                                    style={{
                                                                        color:
                                                                            row?.travelRuleApproved
                                                                                ? '#1da094'
                                                                                : row?.travelRuleRejected
                                                                                    ? '#dd3c3c'
                                                                                    : row?.needsTravelRule
                                                                                        ? '#f0ad4e'
                                                                                        : '#9AA6B2',
                                                                        fontWeight: 600,
                                                                        whiteSpace: 'nowrap'
                                                                    }}
                                                                >
                                                                    {row?.displayStatus ||
                                                                        row?.depositStatusText ||
                                                                        'Processing'}
                                                                </span>
                                                            </StyledTableCell>

                                                            {/* Date */}
                                                            <StyledTableCell>
                                                                {formatBybitDate(
                                                                    row?.successAt ||
                                                                    row?.createdDate
                                                                )}
                                                            </StyledTableCell>

                                                            {/* Action */}
                                                            <StyledTableCell>
                                                                {row?.needsTravelRule ? (

                                                                    <Button
                                                                        variant="contained"
                                                                        className='act-btn accept'

                                                                        onClick={() =>
                                                                            openTravelRuleModal(
                                                                                row
                                                                            )
                                                                        }
                                                                    >
                                                                        Verify
                                                                    </Button>
                                                                ) : (
                                                                    <Button
                                                                        variant="outlined"
                                                                        className='act-btn decline'
                                                                        onClick={() =>
                                                                            openDepositDetails(
                                                                                row
                                                                            )
                                                                        }
                                                                    >
                                                                        Details
                                                                    </Button>
                                                                )}
                                                            </StyledTableCell>
                                                        </TableRow>
                                                    )
                                                }
                                            })}
                                        {depositcryptoList.length == 0 && (
                                            <TableRow>
                                                <StyledTableCell
                                                    component='th'
                                                    scope='row'
                                                ></StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                                {/* <StyledTableCell></StyledTableCell> */}
                                                <StyledTableCell>
                                                    <img
                                                        className='no-record-image'
                                                        src='/assets/no-re.png'
                                                        alt='no-record'
                                                    />
                                                    <br />
                                                    <span className='text-center'>No Records Found</span>
                                                </StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}

                        <div
                            className='d-flex justify-content-end align-items-center mt-3'
                            style={{
                                gap: '8px'
                            }}
                        >

                            <button
                                type='button'
                                disabled={
                                    depositHistoryLoading ||
                                    depositPage <= 1
                                }
                                onClick={() => {
                                    const previousPage =
                                        depositPage - 1

                                    const previousCursor =
                                        depositPageCursors[
                                        previousPage - 1
                                        ] || null

                                    getparticularHistory(
                                        curCurrencySymbol ||
                                        defaultCurrencyList?.currencySymbol,
                                        previousCursor || '',
                                        previousPage
                                    )
                                }}
                                style={{
                                    minWidth: '80px',
                                    height: '36px',
                                    borderRadius: '10px',
                                    border:
                                        '1px solid rgba(255,255,255,0.08)',
                                    backgroundColor:
                                        'rgba(255,255,255,0.04)',
                                    color: 'rgba(226,232,240,0.95)',
                                    cursor:
                                        depositHistoryLoading ||
                                            depositPage <= 1
                                            ? 'not-allowed'
                                            : 'pointer',
                                    opacity:
                                        depositHistoryLoading ||
                                            depositPage <= 1
                                            ? 0.45
                                            : 1
                                }}
                            >
                                Previous
                            </button>

                            <div
                                style={{
                                    minWidth: '42px',
                                    height: '36px',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor:
                                        'rgba(29,160,148,0.12)',
                                    border:
                                        '1px solid rgba(29,160,148,0.25)',
                                    color: '#1da094',
                                    fontWeight: 600,
                                    fontSize: '14px'
                                }}
                            >
                                {depositPage}
                            </div>

                            <button
                                type='button'
                                disabled={
                                    depositHistoryLoading ||
                                    !depositNextPageCursor
                                }
                                onClick={() => {
                                    if (
                                        !depositNextPageCursor
                                    )
                                        return

                                    const nextPage =
                                        depositPage + 1

                                    getparticularHistory(
                                        curCurrencySymbol ||
                                        defaultCurrencyList?.currencySymbol,
                                        depositNextPageCursor,
                                        nextPage
                                    )
                                }}
                                style={{
                                    minWidth: '80px',
                                    height: '36px',
                                    borderRadius: '10px',
                                    border:
                                        '1px solid rgba(255,255,255,0.08)',
                                    backgroundColor:
                                        'rgba(255,255,255,0.04)',
                                    color: 'rgba(226,232,240,0.95)',
                                    cursor:
                                        depositHistoryLoading ||
                                            !depositNextPageCursor
                                            ? 'not-allowed'
                                            : 'pointer',
                                    opacity:
                                        depositHistoryLoading ||
                                            !depositNextPageCursor
                                            ? 0.45
                                            : 1
                                }}
                            >
                                Next
                            </button>
                        </div>

                    </div>
                    <div
                        className='modal fade deposit-crypto-modal'
                        id='selectcoinModal'
                        tabindex='-1'
                        aria-labelledby='exampleModalLabel'
                        aria-hidden='true'
                    >
                        <div className='modal-dialog modal-dialog-centered modal-dialog-scrollable'>
                            <div className='modal-content'>
                                <div className='modal-header '>
                                    <h4 className='modal-title' id='exampleModalLabel'>
                                        Select coin to deposit
                                    </h4>
                                    <button
                                        type='button'
                                        className='btn-close'
                                        data-bs-dismiss='modal'
                                        aria-label='Close'
                                    ></button>
                                </div>
                                <div className='modal-body modal-2-overflow-scroll'>
                                    <input
                                        id='myInput2'
                                        type='text'
                                        placeholder='Search here...'
                                        autoComplete='off'
                                        name='search'
                                        onChange={handleSearch}
                                    />
                                    <ul id='myUL2'>
                                        {currencyList.length > 0 &&
                                            currencyList.map((currency, i) => {
                                                if (currency.currencySymbol != 'INR') {
                                                    return (
                                                        <li
                                                            onClick={() =>
                                                                handleCurrencyChange(currency.value)
                                                            }
                                                        >
                                                            <a
                                                                data-bs-dismiss='modal'
                                                                className='deposit-modal-list-sizing'
                                                            >
                                                                <div className='row deposit-modal-row-sizing'>
                                                                    <div className='col-1'>
                                                                        <img
                                                                            src={currency.image}
                                                                            alt='logo'
                                                                            className='me-1 deposit-modal-coin-images'
                                                                        />
                                                                    </div>
                                                                    <div className='col'>
                                                                        <div className='row ps-2'>
                                                                            <span className='deposit-modal-coin-heading'>
                                                                                {currency.currencySymbol}
                                                                            </span>
                                                                            <span className='deposit-modal-coin-muted-text '>
                                                                                {currency.currencyName}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </li>
                                                    )
                                                }
                                            })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className='modal fade deposit-crypto-modal'
                        id='depositnetworkModal'
                        tabindex='-1'
                        aria-labelledby='exampleModalLabel'
                        aria-hidden='true'
                    >
                        <div className='modal-dialog modal-dialog-centered modal-dialog-scrollable'>
                            <div className='modal-content'>
                                <div className='modal-header'>
                                    <h4 className='modal-title' id='exampleModalLabel'>
                                        Select network
                                    </h4>
                                    <button
                                        type='button'
                                        className='btn-close'
                                        data-bs-dismiss='modal'
                                        aria-label='Close'
                                    ></button>
                                </div>
                                <div className='modal-body modal-2-overflow-scroll'>
                                    <p className='select-network-text-1 pb-3'>
                                        Please note that only supported networks on platform are
                                        shown, if you deposit via another network your assets may be
                                        lost.
                                    </p>
                                    <ul id='myUL2'>
                                        {networkList.length > 0 &&
                                            networkList.map((item, i) => {
                                                const itemNetworkId =
                                                    item._id ||
                                                    `${String(item.currency || '').toUpperCase()}-${item.chain}`

                                                const isSelected =
                                                    itemNetworkId == defaultNetwork

                                                return (
                                                    <li
                                                        key={
                                                            item._id ||
                                                            `${item.currency}-${item.chain}-${i}`
                                                        }
                                                        selected={isSelected}
                                                        onClick={() =>
                                                            handlenetworkChange(itemNetworkId)
                                                        }
                                                    >
                                                        <a
                                                            data-bs-dismiss='modal'
                                                            className='deposit-modal-list-sizing'
                                                        >
                                                            <div className='row deposit-modal-network-sizing'>
                                                                <span className='deposit-modal-coin-heading'>
                                                                    {item.chainType ||
                                                                        item.chain ||
                                                                        '-'}
                                                                </span>

                                                                <span className='deposit-modal-coin-muted-text'>
                                                                    {item.chain &&
                                                                        item.chainType &&
                                                                        item.chain !==
                                                                        item.chainType
                                                                        ? item.chain
                                                                        : ''}
                                                                </span>
                                                            </div>
                                                        </a>
                                                    </li>
                                                )
                                            })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {travelRuleModal && (
                        <div
                            className='utr-overlay'
                            role='dialog'
                            aria-modal='true'
                            onMouseDown={(e) => {
                                if (e.target === e.currentTarget && !travelRuleSubmitting) closeTravelRuleModal();
                            }}
                        >
                            <div className='utr-modal'>

                                {/* HEADER */}
                                <div className='utr-header'>
                                    <h5 className='utr-title'>Travel Rule Verification</h5>
                                    <button type='button' className='utr-close' onClick={closeTravelRuleModal}
                                        disabled={travelRuleSubmitting} aria-label='Close'>
                                        <svg width='14' height='14' viewBox='0 0 24 24' fill='none'>
                                            <path d='M6 6L18 18M18 6L6 18' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
                                        </svg>
                                    </button>
                                </div>

                                <form className='utr-form' onSubmit={submitTravelRule}>
                                    <div className='utr-body'>

                                        {/* INFO BOX */}
                                        <div className='utr-info'>
                                            <svg width='18' height='18' viewBox='0 0 24 24' fill='none'>
                                                <path d='M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 3z'
                                                    stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round' />
                                            </svg>
                                            <span>
                                                In accordance with local regulations, you must provide the originator's information.
                                                If the details do not match, the transaction may be rejected. By submitting this form,
                                                you confirm that all information is true, accurate and complete.
                                            </span>
                                        </div>

                                        {/* DEPOSIT FROM */}
                                        <div className='utr-field'>
                                            <label>Deposit from</label>
                                            <UtrSelect
                                                name='walletType'
                                                value={travelRuleForm.walletType}
                                                options={DEPOSIT_FROM_OPTIONS}
                                                onChange={handleTravelRuleChange}
                                                disabled={travelRuleSubmitting}
                                                searchable
                                            />
                                        </div>

                                        {/* EXCHANGE: originating exchange (dynamic from Bybit API) */}
                                        {travelRuleForm.walletType === '0' && (
                                            <div className='utr-field'>
                                                <label>Originating exchange</label>
                                                <UtrSelect
                                                    name='vaspCode'
                                                    value={travelRuleForm.vaspCode}
                                                    options={vaspList}
                                                    onChange={handleTravelRuleChange}
                                                    disabled={travelRuleSubmitting}
                                                    loading={vaspLoading}
                                                    searchable
                                                />
                                            </div>
                                        )}

                                        {/* PERSONAL WALLET: whose wallet */}
                                        {travelRuleForm.walletType === '1' && (
                                            <div className='utr-field'>
                                                <label>Whose wallet is this?</label>
                                                <UtrSelect
                                                    name='walletOwner'
                                                    value={travelRuleForm.walletOwner}
                                                    options={WALLET_OWNER_OPTIONS}
                                                    onChange={handleTravelRuleChange}
                                                    disabled={travelRuleSubmitting}
                                                />
                                            </div>
                                        )}

                                        {/* ORIGINATOR (exchange ba Another Person's Wallet hole) */}
                                        {(travelRuleForm.walletType === '0' || travelRuleForm.walletOwner === 'other') && (
                                            <>
                                                {/* Individual / Company pills */}
                                                <div className='utr-pills'>
                                                    <button
                                                        type='button'
                                                        className={`utr-pill ${travelRuleForm.legalType === 'individual' ? 'active' : ''}`}
                                                        disabled={travelRuleSubmitting}
                                                        onClick={() => handleTravelRuleChange({ target: { name: 'legalType', value: 'individual', type: 'button' } })}
                                                    >
                                                        <svg width='15' height='15' viewBox='0 0 24 24' fill='none'>
                                                            <circle cx='12' cy='12' r='9' stroke='currentColor' strokeWidth='1.8' />
                                                            <circle cx='12' cy='10' r='3' stroke='currentColor' strokeWidth='1.8' />
                                                            <path d='M6.5 18.5c1.2-2 3.2-3 5.5-3s4.3 1 5.5 3' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' />
                                                        </svg>
                                                        Individual
                                                    </button>

                                                    <button
                                                        type='button'
                                                        className={`utr-pill ${travelRuleForm.legalType === 'company' ? 'active' : ''}`}
                                                        disabled={travelRuleSubmitting}
                                                        onClick={() => handleTravelRuleChange({ target: { name: 'legalType', value: 'company', type: 'button' } })}
                                                    >
                                                        <svg width='15' height='15' viewBox='0 0 24 24' fill='none'>
                                                            <rect x='5' y='3' width='14' height='18' rx='1' stroke='currentColor' strokeWidth='1.8' />
                                                            <path d='M9 8h2M13 8h2M9 12h2M13 12h2M10 21v-4h4v4' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' />
                                                        </svg>
                                                        Company
                                                    </button>
                                                </div>

                                                {travelRuleForm.legalType === 'individual' ? (
                                                    <div className='utr-field'>
                                                        <label>Originator's name</label>
                                                        <div className='utr-two-col'>
                                                            <input type='text' className='utr-input' name='firstName'
                                                                value={travelRuleForm.firstName || ''}
                                                                onChange={handleTravelRuleChange}
                                                                placeholder='First name'
                                                                disabled={travelRuleSubmitting} maxLength={128} />
                                                            <input type='text' className='utr-input' name='lastName'
                                                                value={travelRuleForm.lastName || ''}
                                                                onChange={handleTravelRuleChange}
                                                                placeholder='Last name'
                                                                disabled={travelRuleSubmitting} maxLength={128} />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='utr-field'>
                                                        <label>Originator's company name</label>
                                                        <input type='text' className='utr-input' name='companyName'
                                                            value={travelRuleForm.companyName || ''}
                                                            onChange={handleTravelRuleChange}
                                                            placeholder='Company name'
                                                            disabled={travelRuleSubmitting} maxLength={256} />
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {/* CONFIRM */}
                                        <label className='utr-check' htmlFor='utrConfirm'>
                                            <input
                                                type='checkbox'
                                                id='utrConfirm'
                                                name='confirmed'
                                                checked={Boolean(travelRuleForm.confirmed)}
                                                onChange={handleTravelRuleChange}
                                                disabled={travelRuleSubmitting}
                                            />
                                            <span>
                                                I confirm that the information provided above is complete and correct
                                                to the best of my knowledge.
                                            </span>
                                        </label>
                                        {travelRuleErrors ?
                                            <p className='utr-error'>
                                                {travelRuleErrors}
                                            </p> : null}
                                    </div>

                                    <div className='utr-actions'>
                                        <button type='submit' className='utr-btn utr-submit'
                                            disabled={travelRuleSubmitting || !isTravelRuleFormValid()}>
                                            {travelRuleSubmitting ? (<><span className='utr-spinner' />Submitting...</>) : 'Submit'}
                                        </button>
                                        <button type='button' className='utr-btn utr-back'
                                            onClick={closeTravelRuleModal} disabled={travelRuleSubmitting}>
                                            Back
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </section>
    )
}

export default DepositCrypto
